/* TWAC Discovery Centre behaviour */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.header__search .search-modal__content').forEach((modal) => {
    const input = modal.querySelector('input[type="search"]');
    const discovery = modal.querySelector('[data-twac-discovery]');
    if (!input || !discovery) return;

    const filters = discovery.querySelectorAll('[data-twac-filter]');
    const update = () => {
      const hasQuery = input.value.trim().length > 0;
      modal.classList.toggle('twac-search-has-query', hasQuery);
      discovery.setAttribute('aria-hidden', hasQuery ? 'true' : 'false');
      if (hasQuery) filters.forEach((item) => item.removeAttribute('open'));
    };

    ['input','search','change'].forEach((eventName) => input.addEventListener(eventName, update));
    modal.querySelector('button[type="reset"]')?.addEventListener('click', () => setTimeout(() => { update(); input.focus(); }, 20));

    filters.forEach((filter) => filter.addEventListener('toggle', () => {
      if (!filter.open) return;
      filters.forEach((other) => { if (other !== filter) other.removeAttribute('open'); });
    }));

    discovery.querySelectorAll('.twac-discovery__mobile-accordions details').forEach((panel) => panel.addEventListener('toggle', () => {
      if (!panel.open) return;
      discovery.querySelectorAll('.twac-discovery__mobile-accordions details').forEach((other) => { if (other !== panel) other.removeAttribute('open'); });
    }));

    modal.closest('details')?.addEventListener('toggle', (event) => {
      if (event.currentTarget.open) setTimeout(update, 20);
    });
    update();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-twac-filter][open]').forEach((item) => item.removeAttribute('open'));
  });
});
